import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const CustomSearchIcon = (props: SvgIconProps) => (
  /* eslint-disable-next-line react/jsx-props-no-spreading */
  <SvgIcon xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
    <path
      // eslint-disable-next-line max-len
      d="M16.25 14.2549H15.46L15.18 13.9849C16.16 12.8449 16.75 11.3649 16.75 9.75488C16.75 6.16488 13.84 3.25488 10.25 3.25488C6.66 3.25488 3.75 6.16488 3.75 9.75488C3.75 13.3449 6.66 16.2549 10.25 16.2549C11.86 16.2549 13.34 15.6649 14.48 14.6849L14.75 14.9649V15.7549L19.75 20.7449L21.24 19.2549L16.25 14.2549ZM10.25 14.2549C7.76 14.2549 5.75 12.2449 5.75 9.75488C5.75 7.26488 7.76 5.25488 10.25 5.25488C12.74 5.25488 14.75 7.26488 14.75 9.75488C14.75 12.2449 12.74 14.2549 10.25 14.2549Z"
      fill="currentColor"
    />
  </SvgIcon>
)

export default CustomSearchIcon
